import { action } from "mobx";
import { MainDatabaseRef } from "../config/firebase";
import { isProduction } from "src/utils/Constants";

const BaseUrl = isProduction
  ? "https://asia-southeast2-obat-io.cloudfunctions.net"
  : "http://localhost:5001/obat-io/asia-southeast2";

class SessionStore {
  _isRegisteringSession = false;

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  @action async sessionRegister({ sessionId, userAgent }) {
    if (this._isRegisteringSession) return false;
    this._isRegisteringSession = true;
    try {
      const token = await this.rootStore.getFirebaseIdToken();
      const response = await fetch(BaseUrl + "/sessions_add", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: sessionId,
          userAgent,
        }),
      });

      if (response.ok) {
        return true;
      }

      let responseBody = {};
      try {
        responseBody = await response.json();
      } catch (parseError) {
        responseBody = {};
      }

      throw new Error(
        responseBody.message ||
          `sessions_add failed with status ${response.status}`
      );
    } catch (error) {
      console.error("sessionRegister failed", error);
      return false;
    } finally {
      this._isRegisteringSession = false;
    }
  }

  // @action async sessionUnregister({ sessionId }) {
  //   if (this._isRegisteringSession) return false;
  //   this._isRegisteringSession = true;
  //   try {
  //     const token = await this.rootStore.getFirebaseIdToken();
  //     const response = await fetch(BaseUrl + "/session_remove", {
  //       method: "POST",
  //       headers: {
  //         Authorization: "Bearer " + token,
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         id: sessionId,
  //       }),
  //     });
  //
  //     if (!response.ok) {
  //       throw new Error(`session_remove failed with status ${response.status}`);
  //     }
  //
  //     return true;
  //   } catch (error) {
  //     console.error("sessionUnregister failed", error);
  //     return false;
  //   } finally {
  //     this._isRegisteringSession = false;
  //   }
  // }

  @action async sessionCheck(sessionId) {
    const store = this.rootStore;
    if (
      !store.authenticated ||
      !store._sessionCheckEnabled ||
      store._sessionKickModalShown
    ) {
      return true;
    }
    const uid = store.userFirebase?.uid;
    if (!sessionId || !uid) {
      return true;
    }
    try {
      const snapshot = await MainDatabaseRef.child("users")
        .child(uid)
        .child("sessions")
        .child(sessionId)
        .once("value");

      if (!snapshot.exists()) {
        await store.handleSessionKickedOut();
        return false;
      }

      return true;
    } catch (error) {
      console.error("sessionCheck failed", error);
      return false;
    }
  }
}

export default SessionStore;